import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines class names using clsx and merges Tailwind classes intelligently.
 * This is the standard utility for className composition in this application.
 *
 * @example
 * cn('px-2 py-1', condition && 'bg-blue-500', 'text-white')
 * // => 'px-2 py-1 bg-blue-500 text-white' (if condition is true)
 *
 * @example
 * cn('px-2 py-1 bg-red-500', 'bg-blue-500')
 * // => 'px-2 py-1 bg-blue-500' (blue wins due to twMerge)
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
